import styled from '@emotion/styled'
import { Text } from 'theme-ui'

import media from './../../../common/MediaQueries'
import { transition } from './../../../common/Mixins'
import { WithTheme } from './../../../setup/index'

const PromotionBoxStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 1.5625rem;
  box-shadow: 0rem 0.1875rem 0.625rem 0rem rgba(0, 0, 0, 0.3);
  overflow: hidden;
`

const PromotionBoxImageStyled = styled.div<WithTheme>`
  width: 100%;
  height: 12.5rem;
  background-color: ${({ theme }) => theme.colors.gray};

  @media ${media.phone} {
    height: 16.375rem;
  }
`

const PromotionBoxContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 1.5rem 1.375rem 3.25rem;
  flex: 1;

  @media ${media.phone} {
    padding: 1.75rem 1.625rem 3.125rem;
  }
`

const PromotionBoxTitleStyled = styled(Text)<WithTheme>`
  font-size: 1.5625rem;
  color: ${({ theme }) => theme.colors.green};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  font-family: ${({ theme }) => theme.fonts.secondary};
  margin-bottom: 1.25rem;

  @media ${media.phone} {
    margin-bottom: 2rem;
  }
`

const PromotionBoxSubtitleStyled = styled(Text)`
  font-size: 1.0625rem;
  text-transform: uppercase;
  font-weight: 500;

  margin-bottom: 1.25rem;

  @media ${media.phone} {
    margin-bottom: 2rem;
  }
`

const PromotionBoxDescriptionStyled = styled(Text)`
  font-size: 1.0625rem;
  font-weight: 500;

  margin-bottom: 1.25rem;

  @media ${media.phone} {
    margin-bottom: 2rem;
  }
`

const PromotionBoxListStyled = styled.div`
  margin-bottom: 2rem;
  @media ${media.phone} {
    margin-bottom: 2.875rem;
  }
`

const PromotionBoxListHeadStyled = styled(Text)<WithTheme>`
  font-size: 1.0625rem;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  margin-bottom: 1.25rem;

  @media ${media.phone} {
    margin-bottom: 1.125rem;
  }
`

const PromotionBoxListBodyStyled = styled.div``

const PromotionBoxFooterStyled = styled.div`
  margin-top: auto;
`

const PromotionBoxFooterCaptionStyled = styled(Text)<WithTheme>`
  ${transition}
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.green};
  font-weight: 500;

  &:hover {
    opacity: 0.7;
  }
`

const PromotionBoxFooterButtonStyled = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1rem;

  @media ${media.phone} {
    margin-top: 2rem;
  }
`

// list
const PromotionListStyled = styled.ul`
  display: flex;
  flex-direction: column;
`
const PromotionListItemStyled = styled.li<WithTheme>`
  position: relative;
  font-size: 1.0625rem;
  font-weight: 500;

  ${({ theme }) => (theme.direction === 'rtl' ? 'padding-right: 1rem;' : 'padding-left: 1rem;')}
  ${({ theme }) => (theme.direction === 'rtl' ? ' text-align: right;' : ' text-align: left;')}

  &:not(:last-of-type) {
    margin-bottom: 1rem;
  }

  &:before {
    content: '-';
    position: absolute;
    color: ${({ theme }) => theme.colors.green};
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    ${({ theme }) => (theme.direction === 'rtl' ? 'right: 0;' : 'left: 0;')}
  }

  @media ${media.phone} {
    &:not(:last-of-type) {
      margin-bottom: 2rem;
    }
  }
`

export {
  PromotionBoxStyled,
  PromotionBoxImageStyled,
  PromotionBoxContentStyled,
  PromotionBoxTitleStyled,
  PromotionBoxSubtitleStyled,
  PromotionBoxDescriptionStyled,
  PromotionBoxListStyled,
  PromotionBoxListHeadStyled,
  PromotionBoxListBodyStyled,
  PromotionBoxFooterStyled,
  PromotionBoxFooterCaptionStyled,
  PromotionBoxFooterButtonStyled,
  PromotionListStyled,
  PromotionListItemStyled
}
